import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {SipSocketService} from './sip-socket.service';

@NgModule({
  imports: [
    CommonModule
  ],
  declarations: [],
  providers: [
    SipSocketService
  ]
})
export class WebSocketModule {
}
